const constants = {
  roles: {
    super_admin: "Super Admin",
    admin: "Admin"
  },
  permissions: {
    create_companies: "create:companies"
  },
  messages:{
    something_went_wrong: "something went wrong",
    success: "success",
    api_failed: "api failed",
  },
  awsStaticPath: "https://s3.us-east-1.amazonaws.com/com.technolica.dev/"
}

export {
  constants
}
